<template>
  <div class="block hover:bg-gray-50">
    <div class="flex items-center px-4 py-4 sm:px-6">
      <div class="min-w-0 flex-1 flex items-center">
        <div class="flex-shrink-0">
          <AgentAvatar v-bind:agent="agent" />
        </div>
        <div class="min-w-0 flex-1 px-4 md:grid md:grid-cols-3 md:gap-4">
          <div>
            <p class="text-sm font-medium text-indigo-600 truncate">{{ agent.attributes.name }}</p>
            <p class="mt-2 flex items-center text-sm text-gray-500" v-if="agent.attributes.email">
              <MailIcon class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" aria-hidden="true" />
              <span class="truncate">{{ agent.attributes.email }}</span>
            </p>
            <p class="mt-2 flex items-center text-sm text-gray-500" v-if="isBusinessAgent">
              <span v-tippy>{{ $t('agent.businessAgent') }}</span>
              <tippy>
                {{ $t('agent.businessAgentLabel') }}
              </tippy>
            </p>
          </div>
          <div class="hidden md:block">
            <div>
              <p class="mt-2 flex items-center text-sm text-gray-500">
                <span class="inline-flex rounded-full px-2 text-xs font-semibold leading-5" :class="{'text-green-800 bg-green-100 ': agent.attributes.confirmed, 'text-gray-800 bg-gray-100 ': !agent.attributes.confirmed}">
                  <span v-if="agent.attributes.confirmed">{{ $t('agent.active') }}</span><span v-else>{{ $t('agent.inactive') }}</span>
                </span>
              </p>
            </div>
          </div>
          <div class="hidden md:block">
            <p v-if="agentGroups.length > 0" class="mt-2 text-sm text-gray-500">
              <VLink href="/settings/flow">
                <span v-for="group of agentGroups" v-bind:key="group.id" class="inline-block mr-2">
                  <span class="inline-flex rounded-full px-2 text-xs font-semibold leading-5 text-indigo-800 bg-indigo-100 ">
                    {{group.attributes.name}}
                  </span>
                </span>
              </VLink>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import AgentAvatar from './AgentAvatar.vue'
import { MailIcon } from '@heroicons/vue/solid';
import { useGroupStore } from '@/stores/groups';
import VLink from '../page/VLink.vue'

export default {
  name: 'AgentListItem',
  props: ['agent'],
  setup() {
    let groupStore = useGroupStore();
    return { groupStore };
  },
  components: {
    AgentAvatar,
    VLink,
    //
    MailIcon,
  },
  computed: {
    agentGroups() {
      let ids = [];
      this.agent.relationships.groups.data.forEach(group => {
        ids.push(group.id);
      });
      return this.groupStore.getGroupsByIds(ids);
    },
    isBusinessAgent() {
      if (this.$root.currentBusiness) {
        return this.agent.id === this.$root.currentBusiness.id;
      } else {
        return false;
      }
    },
  },
}
</script>
